import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LibraryLibraryIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12.15 2.25H9.85C8.97 2.25 8.25 2.97 8.25 3.85V20.15C8.25 21.03 8.97 21.75 9.85 21.75H12.15C13.03 21.75 13.75 21.03 13.75 20.15V3.85C13.75 2.97 13.03 2.25 12.15 2.25ZM12.25 20.15C12.25 20.2 12.21 20.25 12.15 20.25H9.85C9.8 20.25 9.75 20.21 9.75 20.15V3.85C9.75 3.8 9.79 3.75 9.85 3.75H12.15C12.2 3.75 12.25 3.79 12.25 3.85V20.15Z"
        fill={color}
      />
      <path
        d="M23.26 19.31L20.16 5.31001C19.99 4.47001 19.09 3.90001 18.25 4.10001L16 4.60001C15.14 4.79001 14.59 5.65001 14.78 6.51001L17.88 20.51C18.07 21.38 18.95 21.92 19.79 21.72L22.04 21.22C22.88 21.05 23.46 20.15 23.26 19.31ZM21.72 19.75L19.47 20.25C19.41 20.26 19.36 20.23 19.35 20.18L16.25 6.18001C16.24 6.13001 16.27 6.07001 16.33 6.06001L18.58 5.56001C18.64 5.54001 18.69 5.58001 18.7 5.64001L21.8 19.64C21.8 19.64 21.77 19.75 21.72 19.76V19.75Z"
        fill={color}
      />
      <path
        d="M5.15 2.25H2.85C1.97 2.25 1.25 2.97 1.25 3.85V20.15C1.25 21.03 1.97 21.75 2.85 21.75H5.15C6.03 21.75 6.75 21.03 6.75 20.15V3.85C6.75 2.97 6.03 2.25 5.15 2.25ZM5.25 20.15C5.25 20.2 5.21 20.25 5.15 20.25H2.85C2.8 20.25 2.75 20.21 2.75 20.15V3.85C2.75 3.8 2.79 3.75 2.85 3.75H5.15C5.2 3.75 5.25 3.79 5.25 3.85V20.15Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

LibraryLibraryIcon.displayName = 'LibraryLibraryIcon';
